module.exports = __webpack_public_path__ + "img/t3-17.a583bb51.svg";